import React from 'react';
import { Box } from '@mui/material';

export const PerspectiveDimCellRenderer = ({ value, data, colDef }) => {
  if (value == null) return null;

  const rowIconsFn = colDef.rowIconsFn;

  let rowIcons = null;
  if (rowIconsFn){
    rowIcons = rowIconsFn(data).map(rowIcon =>
      React.cloneElement(rowIcon, {
        iconKey: rowIcon.key
      })
    );

  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {value}
      {rowIcons && (
        <Box
          component="span"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            ml: 1
          }}
        >
          {rowIcons}
        </Box>
      )}
    </Box>
  )
}